"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncerSimple = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var FieldFormatter_1 = require("../FieldFormatter");
var TextFormatter_1 = require("../TextFormatter");
require("./announcerSimple.css");
var AnnouncerSimple = function (_a) {
    var _b = _a.contentType, contentType = _b === void 0 ? 'default' : _b, props = __rest(_a, ["contentType"]);
    var contentWrapper = function (content) { return ((0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ borderless: true, fontFamily: "alt", fontWeight: "bold", fontSize: "xl" }, { children: content }))); };
    var contentBuilder = function () {
        switch (contentType) {
            case 'money':
                return contentWrapper((0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Money, { amount: props.content }));
            case 'percentage':
                return contentWrapper((0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Percentage, { amount: props.content }));
            case 'default':
                return contentWrapper((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.content }));
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "announcer-simple" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('main-text', props.color, "gap-".concat(props.gap)) }, { children: contentBuilder() })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "sub-element" }, { children: props.footer }))] })));
};
exports.AnnouncerSimple = AnnouncerSimple;
//# sourceMappingURL=AnnouncerSimple.js.map